import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalRole } from '../models/modal-roles';
import { MissingWorkEntry } from '../../api/models';
import { StateService } from '../../services/state.service';
import { ToolService } from '../../services/tool.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lib-missing-work-entry',
  templateUrl: './missing-work-entry.component.html',
  styleUrls: ['./missing-work-entry.component.scss'],
  standalone: false,
})
export class MissingWorkEntryComponent implements OnInit {
  public entries: MissingWorkEntry[] = [];
  public selectedIds = new Set<string>();
  public allSelected: boolean = false;
  public sameDateSelected: boolean = false;
  public sameUserSelected: boolean = false;

  constructor(
    public state: StateService,
    private modalCtrl: ModalController,
    public tools: ToolService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.state.missingWorkEntries$.subscribe((x) => {
      this.entries = x;
      this.selectedIds.clear();
      this.allSelected = false;
      this.sameDateSelected = false;
    });
  }

  // Einzel-Auswahl
  public toggleSelection(id: string, checked: boolean) {
    if (checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }
    this.allSelected = this.selectedIds.size == this.entries.length;
    this.checkDateAndUser();
  }

  private checkDateAndUser() {
    const selectedEntries = this.entries.filter(
      (entry) => entry.id != null && this.selectedIds.has(entry.id)
    );
    if (selectedEntries.length === 0) {
      this.sameDateSelected = false;
      this.sameUserSelected = false;
      return;
    }
    if (selectedEntries.length === 1) {
      this.sameDateSelected = true;
      this.sameUserSelected = true;
      return;
    }
    const firstDate = selectedEntries[0].date;
    const firstUser = selectedEntries[0].user;
    this.sameDateSelected = selectedEntries.every(
      (entry) => entry.date === firstDate
    );
    this.sameUserSelected = selectedEntries.every(
      (entry) => entry.user === firstUser
    );
  }

  public isSelected(id: string): boolean {
    return this.selectedIds.has(id);
  }

  public toggleAll(checked: boolean) {
    if (checked) {
      this.entries.forEach((u) => this.selectedIds.add(u.id));
    } else {
      this.selectedIds.clear();
    }
    this.checkDateAndUser();
  }

  public async delete() {
    await this.state.deleteMissingWorkEntries(Array.from(this.selectedIds));
    this.allSelected = false;
    this.selectedIds.clear();
  }

  public close() {
    this.modalCtrl.dismiss(null, ModalRole.Cancel);
  }

  public async openAbsenceForm() {
    const selectedEntries = this.entries.filter(
      (entry) => entry.id != null && this.selectedIds.has(entry.id)
    );
    const users = selectedEntries.map((x) => x.user);

    await this.modalService.openAbsenceFormModal(
      null,
      null,
      users,
      selectedEntries[0].date
    );
  }
}
